/*
  NO FUGAZI — WhatsApp click attribution.

  The owner wanted to know which surface produced a lead. The first attempt put
  a "[menu]" token on the end of the prefilled message, which meant the customer
  read it. This does the same job without touching the message: it fires a
  dataLayer event on the click, so attribution lands in GTM/GA4 where reporting
  belongs, and the message stays human.

  It also stores the last touch in sessionStorage so the brief form can post the
  same source alongside a submission - that is how a form lead and a WhatsApp
  lead end up attributable to the same surface.

  Source is derived from where the link physically sits, not from a hand-typed
  tag, so a new WhatsApp button anywhere on the site is attributed automatically
  with no extra work.
*/
(function () {
  'use strict';

  function sourceOf(a) {
    if (a.getAttribute('data-wa-source')) return a.getAttribute('data-wa-source');
    if (a.closest('#t4s-menu-drawer, .nf-drawer')) return 'mobile_menu';
    if (a.closest('.t4s-toolbar-mobile, [class*="toolbar_mobile"]')) return 'bottom_bar';
    if (a.closest('header, .t4s-header, [class*="header__"]')) return 'header';
    if (a.closest('footer, .t4s-footer')) return 'footer';
    if (a.closest('[class*="whatsapp-fab"], .nf-fab')) return 'floating_button';
    if (a.closest('.nfc, [class*="configurator"]')) return 'configurator';
    if (a.closest('[class*="nf-tax"], [class*="garment"]')) return 'garment_taxonomy';
    if (a.closest('.nf-spec, [class*="spec-block"]')) return 'spec_block';
    if (a.closest('.nf-brief, [class*="brief"]')) return 'brief_form';
    return 'page_body';
  }

  function garmentOf(a) {
    // The taxonomy chips carry the garment in their own text.
    var chip = a.closest('[class*="chip"]');
    if (chip) return (chip.textContent || '').trim().slice(0, 40);
    return '';
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="wa.me"]') : null;
    if (!a) return;

    var payload = {
      event: 'whatsapp_click',
      wa_source: sourceOf(a),
      wa_garment: garmentOf(a),
      wa_page: location.pathname,
      wa_label: (a.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60)
    };

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (err) { /* analytics must never break a click through to WhatsApp */ }

    // Remember the last touch so a later form submission can carry the same source.
    try {
      sessionStorage.setItem('nf_last_touch', JSON.stringify({
        source: payload.wa_source,
        garment: payload.wa_garment,
        page: payload.wa_page,
        at: new Date().toISOString()
      }));
    } catch (err) { /* private mode: attribution is nice to have, not required */ }
  }, true);

  /* Desktop header "Start your project" (Lead Lab, Nov 2026): an event, not internal UTMs, so the visitor's original source survives. */ document.addEventListener('click', function (e) { var a = e.target && e.target.closest ? e.target.closest('.t4s-nav__ul a[href="/pages/start"]') : null; if (!a) return; try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'start_project_click', placement: 'desktop_header', destination: 'start' }); if (typeof window.gtag === 'function') window.gtag('event', 'start_project_click', { send_to: 'G-S3K17TCJ0X', placement: 'desktop_header', destination: 'start' }); } catch (err) { /* never break the click */ } }, true); // Moved out of an inline block in theme.liquid, which also carried a second
  // whatsapp_click listener. One listener per event, in one file.
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="/pages/download-ebook"], a[href*="/collections/essential-manufacturing-guides"]') : null;
    if (!a) return;
    var host = a.closest('[data-nf-cta]');
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'guide_cta_click',
        cta_location: host ? host.getAttribute('data-nf-cta') : sourceOf(a),
        cta_page: location.pathname,
        cta_label: (a.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60)
      });
    } catch (err) { /* never break the click */ }
  }, true);
})();
